import React from 'react';

import styles from './styles.module.scss';

const CloseButton = (props: React.HTMLProps<HTMLButtonElement>) => (
  <button
    {...props}
    data-testid="button-modal-close-x"
    className={styles['modal-close-button']}
    type="button"
  />
);

export default CloseButton;
